import { Delegate } from 'vendor';

let globalOutsideTouchHandler = null;

class ProductCard extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
        this.delegate = new Delegate(this);
        this.isMobile = window.matchMedia('(max-width: 999px)').matches;
    }

    connectedCallback() {
        this.swiperEl = this.querySelector('.swiper');
        this.productImagesWrapper = this.querySelector('.product-card__figure');

        this.intializeSwiper();

        if (window.matchMedia('(min-width: 1000px)').matches && this.productImagesWrapper) {
            this.productImagesWrapper.addEventListener('mouseenter', this.onMouseEnter.bind(this));
            this.productImagesWrapper.addEventListener('mouseleave', this.onMouseLeave.bind(this));
        }

        if (this.isMobile && this.swiperEl) {
            this.addEventListener('touchstart', this.onMobileInteraction.bind(this), { passive: true });
            this.setupGlobalOutsideTouch();
        }
    }

    disconnectedCallback() {
        this.delegate.off();
        if (this.isMobile) {
            this.removeGlobalOutsideTouch();
        }
    }

    setupGlobalOutsideTouch() {
        if (globalOutsideTouchHandler) return;

        globalOutsideTouchHandler = (event) => {
            const swiperElements = document.querySelectorAll('.swiper');
            let isInsideSwiper = false;

            swiperElements.forEach(swiper => {
                if (swiper.contains(event.target)) {
                    isInsideSwiper = true;
                }
            });

            if (!isInsideSwiper) {
                ProductCard.resetAllCarousels();
            }
        };

        document.addEventListener('touchstart', globalOutsideTouchHandler, { passive: true });
    }

    removeGlobalOutsideTouch() {
        if (globalOutsideTouchHandler) {
            document.removeEventListener('touchstart', globalOutsideTouchHandler);
            globalOutsideTouchHandler = null;
        }
    }

    intializeSwiper() {
        if (!this.swiperEl || typeof Swiper === 'undefined') return;
        if (this.swiperEl.classList.contains('swiper-disabled')) return;
        const disableSwipe = this.hasAttribute('disable-gallery-swipe');
        this.swiper = new Swiper(this.swiperEl, {
            loop: true,
            slidesPerView: 1,
            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            }, 
            touchStartPreventDefault: false,
            touchMoveStopPropagation: false,
            passiveListeners: true,
            breakpoints: {
                768: {
                    allowTouchMove: true,
                },
                1024: {
                    allowTouchMove: !disableSwipe,
                },
            }
        });

        ['.swiper-button-prev', '.swiper-button-next'].forEach((sel) => {
            const btn = this.querySelector(sel);
            if (btn) btn.addEventListener('mousedown', (e) => e.preventDefault());
        });
    }

    onMouseEnter() {
        if (this.swiper) {
            this.swiper.slideToLoop(1, 0);
            this.classList.add('is-active');
        }
    }

    onMouseLeave() {
        if (this.swiper) {
            this.classList.remove('is-active');
        }
    }

    onMobileInteraction() {
        ProductCard.resetOtherCarousels(this);
    }

    static resetOtherCarousels(activeCard) {
        const allCards = document.querySelectorAll('product-card');
        allCards.forEach(card => {
            if (card !== activeCard && card.swiper) {
                card.swiper.slideToLoop(0, 0);
            }
        });
    }

    static resetAllCarousels() {
        const allCards = document.querySelectorAll('product-card');
        allCards.forEach(card => {
            if (card.swiper) {
                card.swiper.slideToLoop(0, 0);
            }
        });
    }
}

if (!window.customElements.get('product-card')) {
    customElements.define('product-card', ProductCard);
}

function initSwatchColorNames(root = document) {
    root.querySelectorAll('.swatch-color-name-display').forEach((display) => {
        if (display._swatchInitialized) return;
        display._swatchInitialized = true;

        const container = display.closest('fieldset') || display.parentElement;
        const nameEl = display.querySelector('.swatch-color-name');

        container.querySelectorAll('a.color-swatch[data-color-name]').forEach((swatch) => {
            swatch.addEventListener('mouseenter', () => {
                nameEl.textContent = swatch.dataset.colorName;
            });
            swatch.addEventListener('mouseleave', () => {
                const active = container.querySelector('a.color-swatch.active[data-color-name]');
                nameEl.textContent = active?.dataset.colorName ?? '';
            });
            swatch.addEventListener('click', () => {
                container.querySelectorAll('a.color-swatch').forEach((s) => s.classList.remove('active'));
                swatch.classList.add('active');
                nameEl.textContent = swatch.dataset.colorName;
            });
        });
    });
}

// variant:change fires on the form — update label from selected option value name
document.addEventListener('variant:change', (event) => {
    const form = event.target;
    const variant = event.detail?.variant;
    if (!variant) return;

    const picker = form.closest('variant-picker') ?? document.querySelector(`variant-picker[form-id="${form.id}"]`);
    if (!picker) return;

    picker.querySelectorAll('.swatch-color-name-display[data-option-position]').forEach((display) => {
        const pos = parseInt(display.dataset.optionPosition, 10) - 1;
        const colorName = variant.options?.[pos];
        if (colorName) display.querySelector('.swatch-color-name').textContent = colorName;
    });
});

document.addEventListener('DOMContentLoaded', () => initSwatchColorNames());
document.addEventListener('shopify:section:load', (e) => initSwatchColorNames(e.target));
document.addEventListener('dialog:after-show', (e) => {
    if (e.target?.matches('quick-buy-modal')) initSwatchColorNames(e.target);
});